import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { TreatmentNames } from './constants';

// Split.io đã được gỡ bỏ khỏi dự án (không dùng nữa). Giữ lại lớp abstraction treatment
// với giá trị fallback tĩnh để không phải sửa các nơi đang đọc treatment. Hành vi y hệt
// trạng thái trước đây khi SPLITIO_ON=false (mọi env đều false).
const treatments: Record<string, string> = {
  BuyerWebNotification: 'control',
  BuyerWebHomePagePopup: process.env.HOMEPAGE_POPUP_TREATMENT || 'off',
};

const selectTreatmentDomain = (_state: ApplicationRootState) => ({ isReady: true, treatments: treatments });

export const selectIsTreatmentReady = () => createSelector(selectTreatmentDomain, (subState) => subState.isReady);

export const selectTreatmentValueByName = (name: TreatmentNames) =>
  createSelector(selectTreatmentDomain, (subState) => subState.treatments[name]);
